import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { styled } from 'styled-components';
import { Media } from '../../..';
const MetaContainer = styled.div `
  display: flex;
  flex-flow: column nowrap;
  gap: 2px;
  padding: 12px;
  ${({ theme }) => theme.typography.textMedium}
  ${({ theme }) => theme.typography.weightMedium}
`;
const MetaHeader = styled.div `
  ${({ theme }) => theme.typography.textMedium}
  color: ${({ theme }) => theme.colors.grey100_1};
`;
const MetaFooter = styled.div `
  ${({ theme }) => theme.typography.textSmall}
`;
const List = styled.div `
  ${({ theme }) => theme.shadows.small}
  border-radius: 8px;
  background: ${({ theme }) => theme.colors.grey00_1};
  display: flex;
  flex-flow: column nowrap;
  margin: auto;
  min-width: 150px;
  & > *:not(last-child) {
    border-bottom: 1px solid ${({ theme }) => theme.colors.grey01_1};
  }

  @media ${Media.smMax} {
    flex-direction: row;
    justify-content: space-between;
    & > *:not(last-child) {
      border-right: 1px solid ${({ theme }) => theme.colors.grey01_1};
    }
  }
`;
// A.k.a AutorInfo
export const MetaUnit = ({ header, content, footer }) => (_jsxs(MetaContainer, { children: [header && _jsx(MetaHeader, { children: header }), content, footer && _jsx(MetaFooter, { children: footer })] }));
export const MetaList = ({ meta }) => (_jsx(List, { children: meta.map((m) => (_jsx(MetaUnit, { ...m }, m.content))) }));
